import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/home/home";
import "./App.css";
import DevListingPage from "./pages/developer/listing/devListing";
import DevDetailpage from "./pages/developer/detail/devDetail";
import UpdateProfilePopup from "./components/popup/update-profile";
import UserContext from "./context/UserContext";
import { useEffect, useState } from "react";
import { userInstance } from "./config/axios";
import { toast } from "react-toastify";
import Dashboard from "./pages/dashboard/dashboard";
import ReviewDetailPage from "./pages/developer/rewiew/reviewdetail";

function App() {
  const [user, setUser] = useState({});
  const [token, setToken] = useState(localStorage.getItem("token"));

  const getProfile = async () => {
    try {
      const res = await userInstance.get(`/${localStorage.getItem("userid")}`, {
        headers: { authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const { data } = res;
      if (data) {
        setUser(data);
      }
    } catch (error) {
      localStorage.removeItem("token");
      toast.error(error.response.data, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    }
  };
  useEffect(() => {
    if (Object.keys(user)?.length === 0 && localStorage.getItem("token")) {
      getProfile();
    }
    //socket.emit("salutations", "Hello!", { "mr": "john" }, Uint8Array.from([1, 2, 3, 4]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className='App'>
      <UserContext.Provider
        value={{
          token,
          setToken,
          user,
          setUser,
        }}
      >
        <Router>
          <Routes>
            <Route exact path='/' element={<HomePage />} />
            <Route
              exact
              path='/developer-listing'
              element={<DevListingPage />}
            />
            <Route exact path='/developer-detail' element={<DevDetailpage />} />
            <Route exact path='/review-detail' element={<ReviewDetailPage />} />
            <Route
              exact
              path='/profile-update'
              element={<UpdateProfilePopup />}
            />
            <Route exact path='/dashboard' element={<Dashboard />} />
          </Routes>
        </Router>
      </UserContext.Provider>
    </div>
  );
}

export default App;
